function handleAddToCart(event, button) {
  event.preventDefault();

  const productCard = button.closest('.product-card-wrapper');
  if (!productCard) return;
  const selectedVariantId = productCard.querySelector('.selected-variant-id').value;
  if (!selectedVariantId) return;

  const lockedWidth = button.offsetWidth + 'px';
  button.style.width = lockedWidth;
  button.style.minWidth = lockedWidth;
  button.setAttribute('disabled', true);
  button.innerHTML = `<span>${button.dataset.labelAdding || 'añadiendo...'}</span>`;

  const formData = {
    id: selectedVariantId,
    quantity: 1,
    sections: ['cart-drawer'],
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && data.sections && data.sections['cart-drawer']) {
        const parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        const newInner = parsed.querySelector('.drawer__inner');
        const currentInner = cartDrawer.querySelector('.drawer__inner');
        if (newInner && currentInner) {
          currentInner.className = newInner.className;
          currentInner.innerHTML = newInner.innerHTML;
        }
        cartDrawer.classList.toggle('is-empty', !newInner || newInner.classList.contains('is-empty'));
        cartDrawer.open();
      } else {
        updateCartDrawer(true);
      }
      if (typeof updateCartIconBubble === 'function') updateCartIconBubble();
    })
    .catch((error) => {
      console.error('Error al agregar al carro:', error);
    })
    .finally(() => {
      button.style.width = '';
      button.style.minWidth = '';
      button.removeAttribute('disabled');
      button.innerHTML = `<span>${button.dataset.labelAdd || 'agregar al carro'}</span>`;
    });
}

function closeSizeSelector(productCard) {
  if (window.innerWidth > 1024) return;
  const sizeSelector = productCard.querySelector('[data-selector="size"]');
  const showSizeButton = productCard.querySelector('[data-action="toggle-selector"]');
  if (sizeSelector) sizeSelector.style.display = '';
  if (showSizeButton) showSizeButton.style.visibility = '';
}

function syncVariantSelection(button) {
  const productCard = button.closest('.product-card-wrapper');
  if (!productCard) return;

  const selectedVariantId = button.dataset.variantId;
  const hiddenVariantInput = productCard.querySelector('.selected-variant-id');
  const submitButton = productCard.querySelector('.product-form__submit');

  if (!selectedVariantId || !hiddenVariantInput) return;

  hiddenVariantInput.value = selectedVariantId;

  const variantButtons = productCard.querySelectorAll('.variant-button');
  variantButtons.forEach((btn) => {
    btn.classList.toggle('selected', btn.dataset.variantId === selectedVariantId);
  });

  if (submitButton) {
    submitButton.disabled = false;
    const span = submitButton.querySelector('span');
    if (span) span.textContent = submitButton.dataset.labelAdd || 'agregar al carro';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  
  function initializeSizeButtons() {
    const productCards = document.querySelectorAll('.product-card-wrapper:not([data-size-buttons-initialized])');
    productCards.forEach((card) => {
      const showSizeButton = card.querySelector('[data-action="toggle-selector"]');
      const sizeSelector = card.querySelector('[data-selector="size"]');
      const closeIcon = card.querySelector('[data-action="close-selector"]');
      
      if (showSizeButton && sizeSelector && closeIcon) {
        showSizeButton.addEventListener('click', function () {
          sizeSelector.style.display = 'block';
          this.style.visibility = 'hidden';
          const btns = sizeSelector.querySelectorAll('.variant-button');
          if (btns.length === 1 && !btns[0].classList.contains('unavailable')) {
            btns[0].classList.add('selected');
          }
        });

        closeIcon.addEventListener('click', function () {
          sizeSelector.style.display = 'none';
          showSizeButton.style.visibility = 'visible';
        });

        card.dataset.sizeButtonsInitialized = 'true';
      }

      if (sizeSelector) {
        const btns = sizeSelector.querySelectorAll('.variant-button');
        if (btns.length === 1 && !btns[0].classList.contains('unavailable')) {
          btns[0].classList.add('selected');
        }
      }
    });
  }
  
  function initializeDragScroll() {
    const variantButtons = document.querySelectorAll('.variant-buttons:not([data-drag-initialized])');
    variantButtons.forEach((container) => {
      let isDown = false;
      let startX;
      let scrollLeft;

      container.addEventListener('mousedown', (e) => {
        isDown = true;
        container.style.cursor = 'grabbing';
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
        e.preventDefault();
      });

      container.addEventListener('mouseleave', () => {
        isDown = false;
        container.style.cursor = 'grab';
      });

      container.addEventListener('mouseup', () => {
        isDown = false;
        container.style.cursor = 'grab';
      });

      container.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 2;
        container.scrollLeft = scrollLeft - walk;
      });

      container.style.cursor = 'grab';
      container.dataset.dragInitialized = 'true';
    });
  }
  
  function initializeAll() {
    initializeSizeButtons();
    initializeDragScroll();
  }

  // Delegated handlers keep variant selection and ATC working
  // for cards injected later by infinite scroll or filter updates.
  document.addEventListener('click', function(event) {
    const variantButton = event.target.closest('.product-card-wrapper .variant-button');
    if (variantButton) {
      event.preventDefault();
      if (!variantButton.disabled && !variantButton.classList.contains('unavailable')) {
        syncVariantSelection(variantButton);
      }
      return;
    }

    const addButton = event.target.closest('.product-card-wrapper .product-form__submit');
    if (addButton && addButton.closest('.product-form')) {
      if (addButton.hasAttribute('onclick')) return;
      handleAddToCart(event, addButton);
    }
  });

  document.addEventListener('submit', function(event) {
    const form = event.target.closest('.product-card-wrapper .product-form');
    if (!form) return;
    const button = form.querySelector('.product-form__submit');
    if (button) {
      handleAddToCart(event, button);
    }
  });
  
  initializeAll();
  
  if (typeof FacetFiltersForm !== 'undefined') {
    const originalRenderProductGridContainer = FacetFiltersForm.renderProductGridContainer;
    FacetFiltersForm.renderProductGridContainer = function(html) {
      originalRenderProductGridContainer.call(this, html);
      setTimeout(() => {
        initializeAll();
      }, 50);
    };
  }
  
  const productGrid = document.querySelector('.product-grid');
  if (productGrid) {
    const observer = new MutationObserver(function(mutations) {
      let shouldReinitialize = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const hasNewProducts = Array.from(mutation.addedNodes).some(node => 
            node.nodeType === 1 && 
            (node.classList?.contains('product-card-wrapper') || 
             node.querySelector?.('.product-card-wrapper'))
          );
          
          if (hasNewProducts) {
            shouldReinitialize = true;
          }
        }
      });
      
      if (shouldReinitialize) {
        setTimeout(() => {
          initializeAll();
        }, 100);
      }
    });
    
    observer.observe(productGrid, {
      childList: true,
      subtree: true
    });
  }
  
  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer) {
    const containerObserver = new MutationObserver(function(mutations) {
      let shouldReinitialize = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          shouldReinitialize = true;
        }
      });
      
      if (shouldReinitialize) {
        setTimeout(() => {
          initializeAll();
        }, 100);
      }
    });
    
    containerObserver.observe(productGridContainer, {
      childList: true,
      subtree: true,
      attributes: false
    });
  }
});

window.handleAddToCart = handleAddToCart;
